module.exports = __webpack_public_path__ + "static/media/icon-edit.c7f5032c.svg";